import { Box, BoxProps } from '@chakra-ui/react';

import Label from '../../components/formComponents/Label';

const InTheMeantime = ({ ...props }: BoxProps) => (
  <Box {...props}>
    <Label fontSize={{ base: 'unset', lg: '20px' }}>IN THE MEANTIME:</Label>
  </Box>
);

export default InTheMeantime;
